// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__bQcJG","notes":"Notes_notes__3iZ_W"};